import axios from "axios"
import { REACT_APP_API } from '../../config'

export const addFile = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post(REACT_APP_API + '/files/', formData, {
    timeout: 30000
  })

  return response.data.data
}
